/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

export default {
    BEST_FIT: 'bestFit',
    VERTICAL: 'vertical',
    HORIZONTAL: 'horizontal'
};
